const container = document.getElementById("qrz-log")

const COLUMNS = [
  ["call", "CALL"],
  ["date", "DATE"],
  ["band", "BAND"],
  ["mode", "MODE"],
  ["grid", "GRID"],
  ["country", "COUNTRY"],
  ["op", "OP"],
]

const element = (tag, className, text) => {
  const node = document.createElement(tag)
  if (className) node.className = className
  if (text != null) node.textContent = text
  return node
}

const renderTable = contacts => {
  const table = element("table", "log-table")
  table.createCaption().appendChild(element("span", "sr-only", `Last ${contacts.length} QSOs, newest first`))
  const headRow = table.createTHead().insertRow()
  headRow.appendChild(element("th", "col-qsl")).appendChild(element("span", "sr-only", "Confirmed"))
  COLUMNS.forEach(([key, label]) => headRow.appendChild(element("th", `col-${key}`, label)))

  const body = table.createTBody()
  contacts.forEach(contact => {
    const row = body.insertRow()
    const qsl = row.appendChild(element("td", "col-qsl"))
    if (contact.confirmed) {
      qsl.appendChild(element("span", null, "*")).setAttribute("aria-hidden", "true")
      qsl.appendChild(element("span", "sr-only", "yes"))
    }
    COLUMNS.forEach(([key]) => {
      const cell = element("td", `col-${key}`)
      if (key === "call") {
        const link = element("a", null, contact.call)
        link.href = `https://www.qrz.com/db/${encodeURIComponent(contact.call)}`
        link.target = "_blank"
        link.rel = "noopener"
        cell.appendChild(link)
      } else {
        cell.textContent = contact[key]
      }
      row.appendChild(cell)
    })
  })
  return table
}

const showFallback = () => {
  container.querySelector(".log-status").textContent = "error: couldn't reach the log right now."
  container.querySelector(".log-fallback").hidden = false
}

if (container) {
  const endpoint = container.dataset.endpoint

  if (!endpoint) {
    showFallback()
  } else {
    fetch(endpoint)
      .then(response => {
        if (!response.ok) throw new Error(`log endpoint responded ${response.status}`)
        return response.json()
      })
      .then(({ contacts, fetchedAt }) => {
        if (!contacts?.length) throw new Error("no contacts in response")
        const fetched = new Date(fetchedAt).toISOString().slice(11, 16)
        container.querySelector(".log-status").replaceWith(renderTable(contacts))
        container.appendChild(element("p", "log-foot", `-- ${contacts.length} QSOs // * = confirmed // fetched ${fetched}Z from logbook.qrz.com`))
      })
      .catch(error => {
        console.error(error)
        showFallback()
      })
  }
}
